var $=jQuery;
// 确保 dataLayer 存在
window.dataLayer = window.dataLayer || [];

// 展示事件
// window.datalayer_popup_even_n = function({event_name, event_category, event_action, event_label, event_remarks}) { 
//   window.dataLayer = window.dataLayer || []; // 确保 dataLayer 存在
//   window.dataLayer.push({
//     event: "dle_custom_eventN",
//     dlv_en: event_name   || "",
//     dlv_ec: event_category || "",  // ✅ 改成动态传入
//     dlv_ea: event_action || "",
//     dlv_el: event_label  || "",
//     dlv_er: event_remarks|| ""     // 区分自动/手动触发
//   });
// };
function GAwheelPopClickClose() {
  // 点击抽奖成功，触发埋点
  const ec_name = 'popUp'
  var path_c = window.location.pathname; 
  console.log('path:',path_c);
  console.log('cleanPath',path_c);
  
  console.log(path_c);
  const ec_categroy = '$'+ path_c;
  const ec_action = 'popUp';
  const ec_label = 'popUp::TurnTable_'+path_c+'::close';
  const ec_remarks = 'clickPop'
  console.log('1GAall:',ec_name,'2',ec_categroy,'3',ec_action,'4',ec_label,'5',ec_remarks);

  // 调用 datalayer 方法
  window.datalayer_popup_even_c({
    event_name: ec_name,
    event_category: ec_categroy,
    event_action: ec_action,
    event_label: ec_label,
    event_remarks: ec_remarks
  });
}
window.GAwheelPopClickClose = GAwheelPopClickClose;
// 加载检测使用有300券包登录标识
document.addEventListener("DOMContentLoaded", function () {
  const loginFlag = sessionStorage.getItem("allVoucherPackageLoginSuccess");

  if (loginFlag === "true") {
    console.log("✅ 用户通过300券包登录");
    
    // 点击登录成功，触发埋点
    const ec_name = 'login_success'
    var path_c = window.location.pathname; 
    console.log('path:',path_c);
    var userId = $('#MainContent').data('ud');  
    console.log("User ID:", userId);
    
    const ec_categroy = '$'+ path_c;
    const ec_action = 'click';
    const ec_label = 'login_success';
    const ec_remarks = '';
    const idc_login = userId;
    console.log('1:',ec_name,'2',ec_categroy,'3',ec_action,'4',ec_label,'5',ec_remarks,'6用户id',idc_login);

    // 调用 datalayer 方法
    window.datalayer_popup_even_c_login({
      event_name: ec_name,
      event_category: ec_categroy,
      event_action: ec_action,
      event_label: ec_label,
      event_remarks: ec_remarks,
      login_id:idc_login
    });



    sessionStorage.removeItem("allVoucherPackageLoginSuccess"); // 用完清掉
  }
});


// x 关闭转盘
$('.sunber-wheel-poupop-con .wheel-spin-box-close-x').on('click',function () {
  GAwheelPopClickClose()
});
// 空白关闭转盘
$(document).on('click', '.sunber-wheel-poupop-con', function (e) {
  // 判断点击的目标是否在 .wheel-poupop 里面
  if ($(e.target).closest('.wheel-poupop').length === 0) {
    // 如果点到的是空白区域（不是 .wheel-poupop 内部）
    // $('.sunber-wheel-poupop-con').hide();
    console.log("点击了空白区域，关闭弹窗执行埋点");
    GAwheelPopClickClose()
  }
});





window.datalayer_popup_even_n = function({event_name, event_category, event_action, event_label, event_remarks}) { 
  window.dataLayer = window.dataLayer || [];

  console.log('11111111111111111111111111111111[datalayer_popup_even_n called]', {
    event_name,
    event_category,
    event_action,
    event_label,
    event_remarks
  });

  window.dataLayer.push({
    event: "dle_custom_eventN",
    dlv_en: event_name    || "",
    dlv_ec: event_category|| "",
    dlv_ea: event_action  || "",
    dlv_el: event_label   || "",
    dlv_er: event_remarks || ""
  });

  console.log('222222222222222222222222222[dataLayer after push]', window.dataLayer);
};


// 点击事件
window.datalayer_popup_even_c = function({event_name, event_category, event_action, event_label, event_remarks}) { 
  window.dataLayer = window.dataLayer || [];

  console.log('3333333333333[datalayer_popup_even_c called]', {
    event_name,
    event_category,
    event_action,
    event_label,
    event_remarks
  });

  window.dataLayer.push({
    event: "dle_custom_eventC",
    dlv_en: event_name    || "",
    dlv_ec: event_category|| "",
    dlv_ea: event_action  || "",
    dlv_el: event_label   || "",
    dlv_er: event_remarks || ""
  });

  console.log('44444444444444[dataLayer after push]', window.dataLayer);
};

// 点击事件
window.datalayer_popup_even_c_login = function({event_name, event_category, event_action, event_label, event_remarks,login_id}) { 
  window.dataLayer = window.dataLayer || [];

  console.log('5555555555555555[datalayer_popup_even_c called]', {
    event_name,
    event_category,
    event_action,
    event_label,
    event_remarks,
    login_id
  });

  window.dataLayer.push({
    event: "dle_custom_event",
    dlv_en: event_name    || "",
    dlv_ec: event_category|| "",
    dlv_ea: event_action  || "",
    dlv_el: event_label   || "",
    dlv_er: event_remarks || "",
    dlv_li:login_id || ""
  });

  console.log('666666666666666666666[dataLayer after push]', window.dataLayer);
};



// function datalayer_popup_even_n() {
//     dataLayer.push({
//         event: "dle_custom_eventN",
//         dlv_en: `{event_name}`,
//         dlv_ec: `路由名`, 
//         dlv_ea: {event_action},
//         dlv_el: {event_label},
//         dlv_er: {event_remarks},//自动弹出个    人为弹出
//         });
// }

// function datalayer_popup_even_c() {
//     dataLayer.push({
//         event: "dle_custom_eventC",
//         dlv_en: `{event_name}`,
//         dlv_ec: `路由名`, 
//         dlv_ea: {event_action},
//         dlv_el: {event_label},
//         dlv_er: {event_remarks},//自动弹出个    人为弹出
//         });

// }